export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14368.1ee19397.jpg";